module.exports = function(app){
    var attachFileAlertModal = require("chmhom/modals/attachFileAlertModal");
    app.controller('pages.message-center.contactUs',['$scope', '$state', 'storage', '$filter', 'coremetrics', '$location', 'messageCenterService', 'modal', 'services','$window','session','$timeout','virusScanService','brand','xml2json','aemContent',
        function($scope, $state, storage, $filter, coremetrics, $location, messageCenterService, modal, services,$window,session,$timeout,virusScanService,brand,xml2json,aemContent){

            $scope.headings = "contact us";
            $scope.sidebar.links = [];

            $scope.phoneNumberMaxLength = 10;
            var brand=brand.current.sharedBrandCode;
            $scope.backAction = function() {
                $window.history.back();
            };
            $scope.attachedFiles=[];
            var _attachedFileCounter = 0;
            $scope.backText = "< Back";
            $scope.viewState="";
            $scope.deleteChar = String.fromCharCode(215);
            $scope.firstMoxieLoad = true;
            $scope.showPicker = true;
            $scope.call_preference_time_one ="8am-11am";
            $scope.call_preference_time_two="11am-2pm";
            $scope.call_preference_time_three="2pm-5pm";



            $scope.reply=false;
            $scope.selectedTopic="";
            var fileArray = [];
            var downloadAttachmentUrl ="/rbsmbl/x-services/download/securemessage/attachment";
            var _attachedBytes = 0;

            var ahPartner = 'None',
                medicare = 'false',
                medigap ='false',
                blueExtraBasic='false',
                blueExtraPlus ='false',
                isPPO ='false',
                isHMO  = 'false';

            $scope.contactUsForm = {
                planId:"",
                reason:"",
                comments:"",
                phone:"",
                attachment: "",
                callPreference: "",
                leaveMessage:""
            };



            $scope.hideCallPreference=false;

            $scope.topics = [];







            //function to initialize moxie plugin for file upload
            var addFile = function () {
                    // designate a DOM element as the file picker button
                    var fileInput = new mOxie.FileInput({
                        browse_button: 'contactUs-attachFile'
                    });


                    fileInput.onmousedown = function (e) {
                        coremetrics.elementTag('MSG-Coremetrics-AttachFile', 'MEMBER:MESSAGE CENTER CONTACT US');
                        if ($scope.attachedFiles && $scope.attachedFiles.length >= 3) {

                            openAttachmentAlertModal('Attachment alert','Attachment with previous attachments will surpass the maximum number of megabytes permitted!');
                        }
                    };

                    // fires when user closes file dialog after a file is selected
                    fileInput.onchange = function (evt) {
                        var fileFilter = "application/pdf,text/plain,image/*,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                        if (evt.target.files && $scope.attachedFiles.length < 3) {

                            // files is a FileList of File objects.
                            for (var i = 0, f; f = evt.target.files[i]; i++) {

                                // check mime type
                                if (!(f.type.match(fileFilter.replace(/,/g, "|")))) {


                                    openAttachmentAlertModal('Attachment alert','<span data-aem-content= "CNTCT_US_ERR_INVALIDFILE"></span>');
                                    return;
                                }

                                // If file is greater than 5MB
                                if (f.size > (Math.pow(1024, 2) * 5)) {


                                    openAttachmentAlertModal('Attachment alert','<span data-aem-content= "CNTCT_US_ERR_FILESIZE"></span>');
                                    return;

                                }

                                // If attached file and previous attached file(s) will surpass the total number of bytes permitted
                                if ((f.size + _attachedBytes) > (Math.pow(1024, 2) * 5)) {


                                    openAttachmentAlertModal('Attachment alert','Attachment with previous attachments will surpass the maximum number of megabytes permitted!');
                                    return;
                                }

                                var reader = new mOxie.FileReader();

                                reader.onloadstart = (function (theFile) {

                                    return function (e) {
                                        // Increment file counter
                                        _attachedFileCounter++;
                                        var attachment = {
                                            "attachmentId": _attachedFileCounter,
                                            "fileUploadStatus": "pending",
                                            "fileName": theFile.name.toLowerCase(),
                                            "fileSize": theFile.size

                                        };
                                        $scope.attachedFiles.push(attachment);
                                        $scope.confirmDeleteAttachment = function (attachmentName) {

                                           var modalButtons=[
                                                {
                                                    buttonLabel:"CANCEL",
                                                    buttonClass:"primary",
                                                    buttonAction:function(){$scope.closeModal();}
                                                },
                                                {
                                                    buttonLabel:"OK",
                                                    buttonClass:"primary",
                                                    buttonAction:function(){$scope.closeModal();$scope.deleteAttachment(attachmentName);}
                                                }
                                            ];

                                            openAttachmentAlertModal('Confirm attachment removal','Are you  sure you want to delete ' + attachmentName.toLowerCase() + '?',modalButtons);

                                        }

                                    };
                                })(f);

                                // Closure to capture the file information.
                                reader.onload = (function (theFile) {

                                    return function (e) {

                                        $scope.fileBinary = e.target.result;

                                        var binaryOnly = $scope.fileBinary.split(',')[1];

                                        // virus scan
                                        services.mhsimb.openAttachment().addFile(binaryOnly, $scope.fileName).then(
                                            function (response) {

                                                var jsonData = xml2json.xml_str2json(response.data);
                                                if(jsonData.attachmentResponseMessage && jsonData.attachmentResponseMessage.baseMessage && jsonData.attachmentResponseMessage.baseMessage.returnCode=='200'){
                                                    $scope.attachedFiles.forEach(function (attachment) {
                                                        if (attachment.fileName ==theFile.name) {
                                                            attachment.fileUploadStatus = "success";
                                                            attachment.attachmentPath = jsonData.attachmentResponseMessage.payload.controlData.DocumentToken;
                                                            attachment.fileBinary = $scope.fileBinary;
                                                        }
                                                    });
                                                    _attachedBytes = _attachedBytes + theFile.size;
                                                }else{
                                                    showFileAttachmentError(theFile.name);
                                                }




                                            },
                                            function (err) {
                                                console.error('fetch failed in getData', err);
                                                showFileAttachmentError(theFile.name);
                                            }
                                        );


                                    };
                                })(f);

                                // Read in the image file as a data URL.
                                reader.readAsDataURL(f);
                            }
                        }


                    };

                    // initialize plugin
                    fileInput.init();



            };

            $scope.deleteAttachment=function(attachmentName){
                if (attachmentName) {
                    var index = -1;
                    var fileSize = 0;
                    for (var i = 0; i < $scope.attachedFiles.length; i++) {
                        if (attachmentName === $scope.attachedFiles[i].fileName) {
                            fileSize = $scope.attachedFiles[i].fileSize;
                            index = i;
                            break;
                        }
                    }

                    if (index > -1) {
                        _attachedBytes = _attachedBytes - fileSize;
                        $scope.attachedFiles.splice(index, 1);
                    }
                }
            };

            var showFileAttachmentError =function(fileName){

                var modalButtons=[
                    {
                        buttonLabel:"OK",
                        buttonClass:"primary",
                        buttonAction:function(){$scope.closeModal();
                        }
                    },
                    {
                        buttonLabel:"CONTINUE",
                        buttonClass:"primary",
                        buttonAction:function(){$scope.closeModal();
                            $scope.attachedFiles=[];}
                    }
                ];


                openAttachmentAlertModal('Error','<span data-aem-content="CNTCT_US_SEC_ATTCH_VIRUS"></span>' ,modalButtons);

                $scope.deleteAttachment(fileName);
            };


            $scope.changeTopic =function() {
                if ($scope.contactUsForm.reason && $scope.contactUsForm.reason === 'CHN') {
                    $scope.showPicker=false;
                    //show attachments invalidate warning message if nurse line topic is selected
                    if ($scope.attachedFiles.length > 0) {
                        $scope.attachmentWarningCancelButton = function () {
                            $scope.contactUsForm.reason = $scope.selectedTopic;
                            modal.close();
                        };

                        var modalButtons=[
                            {
                                buttonLabel:"CANCEL",
                                buttonClass:"primary",
                                buttonAction:function(){$scope.attachmentWarningCancelButton()}
                            },
                            {
                                buttonLabel:"CONTINUE",
                                buttonClass:"primary",
                                buttonAction:function(){$scope.closeModal();
                                    $scope.attachedFiles=[];}
                            }
                        ];

                        openAttachmentAlertModal('<span data-aem-content= "CNTCT_US_LOSE_ATTCH_TITLE"></span>','<span data-aem-content="CNTCT_US_LOSE_ATTCH_DESC"></span>' ,modalButtons);
                    }

                } else if ($scope.contactUsForm.reason) {
                    $scope.showPicker=true;
                    $scope.selectedTopic = $scope.contactUsForm.reason;
                    if ($scope.firstMoxieLoad) {
                        addFile();
                        $scope.firstMoxieLoad = false;
                    }
                }
            };
            //if its reply message
            if ($location.search().reply) {
                $scope.reply=true;
                $scope._messageToReplyTo= storage.get("replyMessage");
                $scope.contactUsForm.reason=$scope.reply?$scope._messageToReplyTo.messageSubCategoryCode:"";
                //invoking addfile/uploadfile plugin
                if ($scope.contactUsForm.reason && $scope.contactUsForm.reason !== 'CHN') {
                    $timeout(function () {
                        if ($scope.firstMoxieLoad) {
                            addFile();
                            $scope.firstMoxieLoad = false;
                        }
                    }, 1000);
                }
            }


            //Message Topics
            $scope.sidebar.fetchCategories = function() {
                var categoryPromise = messageCenterService.getCategories();
                return categoryPromise.then(function(category) {

                    var categoriesArray = category.data.payload.subcategory;
                    categoriesArray.forEach(function(subcat){
                        var topic={
                            value:subcat.campaignMessage[0].campaignMessageId,
                            label:subcat.subCategoryDesc,
                            categoryCode:subcat.subCategoryCode
                        };
                        $scope.topics.push(topic);
                    })
                })
            };
            $scope.sidebar.fetchCategories();
            //if dates equal return 0; if compareDate greater than Date return 1; if compareDate less than Date then return -1
            var dateCompare = function(compareDate, endDate) {
                while(compareDate.indexOf("/") != -1) {
                    compareDate = compareDate.replace("/", "-");
                }
                while(endDate.indexOf("/") != -1) {
                    endDate = endDate.replace("/", "-");
                }
                var compDt = new Date(compareDate).getTime();
                var dt = new Date(endDate).getTime();

                if(compDt > dt) return 1;
                if(compDt == dt) return 0;
                if(compDt < dt) return -1;
            };
            var _fetchPlansAndCSPhoneNumber = function () {

                if(session.data.memberInfo){
                    var arrProdNames = [];
                    var memberInfo = session.data.memberInfo;
                    $scope.messagePlans =  [];

                    for (var iClntIdx = 0; iClntIdx < memberInfo.clientList.length; ++iClntIdx) {
                        var objClnt = memberInfo.clientList[iClntIdx];
                        for (var iGrpIdx = 0; iGrpIdx < objClnt.groupList.length; ++iGrpIdx) {
                            var objGrp = objClnt.groupList[iGrpIdx];
                            if(objGrp.planPartnerCode==='373' || objGrp.planPartnerCode==='374')
                                ahPartner='AHNJ';
                            else if(objGrp.planPartnerCode==='375')
                                ahPartner='AHPA';

                            if(objGrp.medicareIndicator  === 'true')
                                medicare =    'true';

                            if(objGrp.medigapIndicator==='true')
                                medigap   =   'true';


                            for (var iPrdIdx = 0; iPrdIdx < objGrp.productList.length; ++iPrdIdx) {
                                var objPrd = objGrp.productList[iPrdIdx];

                                if(objPrd.isBlueExtraBasic==='true')
                                    blueExtraBasic =  'true';
                                if(objPrd.isBlueExtraPlus==='true')
                                    blueExtraPlus =   'true';
                                if(objPrd.lob  === 'PPO')
                                    isPPO =   'true';
                                if(objPrd.lob  === 'HMO')
                                    isHMO =   'true';

                                //check benefitPlanType to determine icon used
                                var benefitPlanType=objPrd.benefitPlanType;
                               /* if (objPrd.benefitPlanType == "Medical"){
                                    benefitPlanIcon = "<span class='hm-icon icon-provider'></span>";
                                }
                                if (objPrd.benefitPlanType == "Vision"){
                                    benefitPlanIcon = "<span class='hm-icon icon-vision'></span>";
                                }
                                if (objPrd.benefitPlanType == "Dental"){
                                    benefitPlanIcon = "<span class='hm-icon icon-dental'></span>";
                                }
                                if (objPrd.benefitPlanType == "Wellness Programs"){
                                    benefitPlanIcon = "<span class='hm-icon icon-nutrition'></span>";
                                }
                                if (objPrd.benefitPlanType == "Spending Accounts"){
                                    benefitPlanIcon = "<span class='hm-icon icon-cost'></span>";
                                }
                                if (objPrd.benefitPlanType == "Drug"){
                                    benefitPlanIcon = "<span class='hm-icon icon-pharmacy'></span>";
                                }*/

                                //get proper plan name for display
                                var planNameDisplay = "";
                                if(objGrp.hiosName != "" && objGrp.hiosName != null) {
                                    planNameDisplay = objGrp.hiosName;
                                    if(objGrp.qhpLevel != null && objGrp.qhpLevel != "")
                                        planNameDisplay = planNameDisplay + " " + objGrp.qhpLevel;
                                }
                                else {
                                    planNameDisplay = objPrd.benefitPlanName;
                                }

                                for (var iMbrIdx = 0; iMbrIdx < objPrd.memberList.length; ++iMbrIdx) {
                                    var objMbr = objPrd.memberList[iMbrIdx];
                                    var planStatus='';
                                    var fromDate='';
                                    var toDate='';

                                    if(objPrd.coverageBeginDate != null && objPrd.coverageBeginDate != "" && (objMbr.coverageCancellationDate == null || objMbr.coverageCancellationDate == "")) {
                                        var strPrdName =  benefitPlanType+planNameDisplay  + objPrd.coverageBeginDate + '-' + objPrd.coverageEndDate ;
                                        fromDate = objPrd.coverageBeginDate;
                                        toDate = objPrd.coverageEndDate;
                                    } else if (objPrd.coverageBeginDate != null && objPrd.coverageBeginDate != "" && objMbr.coverageCancellationDate != null && objMbr.coverageCancellationDate != ""
                                        && (dateCompare(objMbr.coverageCancellationDate, objPrd.coverageEndDate) < 1)) {
                                       var strPrdName =  benefitPlanType+planNameDisplay + '(Cancelled)(' + objPrd.coverageBeginDate + '-' + objMbr.coverageCancellationDate + ')';
                                        planStatus = "Cancelled";
                                        fromDate = objPrd.coverageBeginDate;
                                        toDate = objMbr.coverageCancellationDate;
                                    }else if ((objPrd.coverageBeginDate == null || objPrd.coverageBeginDate == "") && (objMbr.coverageCancellationDate != null && objMbr.coverageCancellationDate != "")
                                        && (dateCompare(objMbr.coverageCancellationDate, objPrd.coverageEndDate) < 1)) {
                                        var strPrdName = benefitPlanType+planNameDisplay + '(Cancelled)(' + objMbr.coverageCancellationDate + ')';

                                        planStatus = "Cancelled";
                                        fromDate =  objMbr.coverageCancellationDate;

                                    } else {
                                        var strPrdName =  benefitPlanType+planNameDisplay + '(' + objPrd.coverageEndDate + ')';
                                        fromDate =  objPrd.coverageEndDate;
                                    }
                                }

                                if (arrProdNames.indexOf(strPrdName)  == -1) {


                                    //If Blue Extra and Medical, then do not show the plan. Else follow BAU
                                    if(!((objPrd.isBlueExtraBasic ===  'true'  ||  objPrd.isBlueExtraPlus  === 'true')
                                        && objPrd.benefitPlanType   === 'Medical')){

                                        // if there is more than one plan, we need the user to make a selection so that the progressive display can proceed.  So, we need to remove the default selection, which happens below.
                                        $scope.messagePlans.push({
                                            "id": objPrd.lob+"_"+objGrp.groupNumber+"_"+objPrd.productNumber + '_' + iPrdIdx,
                                            "label": strPrdName,
                                            "value": objPrd.lob + objGrp.groupNumber + objPrd.productNumber + '_' + iPrdIdx,
                                            "checked": ($scope.messagePlans.length < 0),
                                            "benefitPlanType":benefitPlanType,
                                            "planNameDisplay":planNameDisplay,
                                            "planStatus":planStatus,
                                            "fromDate":fromDate,
                                            "toDate":toDate,
                                            "selectedClientIndex":iClntIdx,
                                            "selectedGroup":iGrpIdx,
                                            "selectedPlan":iPrdIdx


                                        });
                                    }

                                    arrProdNames.push(strPrdName);
                                }
                            }
                        }
                    }
                    if($scope.messagePlans.length>0){
                        $scope.viewState="success";
                    }
                    if(arrProdNames.length == 1){
                        $scope.contactUsForm.planId= $scope.messagePlans[0].id;
                    }

                    services.rbsmbl.AccountSettingsRetrive().retriveAccountSettings('','',brand,'').then(function(response){
                        $scope.homePhone =  response.payload.homePhone;
                    });
                    services.rbsmbl.csPhoneNumber().fetch(session.data.memberInfo).then(function (response) {
                        if (response && response.data && response.data.payload) {

                            var CSPhoneNumber = response.data.payload.CSPhoneNumber;

                            if (CSPhoneNumber && CSPhoneNumber.replace(/\s/g, '').length > 0) {
                                var last_four, middle_three, area_code, international, len;
                                len = CSPhoneNumber.length;
                                last_four = CSPhoneNumber.substring(len - 4, len);
                                middle_three = CSPhoneNumber.substring(len - 7, len - 4);
                                area_code = CSPhoneNumber.substring(len - 10, len - 7);
                                international = (len == 11) ? CSPhoneNumber.substring(len - 11, len - 10) + '-' : '';
                                CSPhoneNumber = international + area_code + '-' + middle_three + '-' + last_four;
                                $scope.CSPhoneNumber = CSPhoneNumber;

                            } else {
                                $scope.CSGetNumberFromCard = "the number on the back of your member Id card.";
                            }
                        }
                    });


                    postRender($scope.messagePlans);
                }


            };



            // Filter out service Plans
            var filterOutServicePlans = function (plans) {
                var filteredPlans = [];
                for (var i = 0; i < plans.length; i++){

                    //If contains service splice it out
                    if(plans[i].label.indexOf('Service -') == -1)
                    {
                        filteredPlans.push(plans[i])
                    }

                }

                // If filtered plans have more than 0 show that list
                if (filteredPlans.length>0) {
                    return filteredPlans;
                }
                //else show original list
                else {
                    return plans;
                }
            };

            var postRender=function(messagePlans) {
                $scope.messagePlans = filterOutServicePlans(messagePlans);
                //For Minnesota, on the reply page, do not show time preference.
                if (brand && brand.toLowerCase() === 'mincr') {
                    $scope.hideCallPreference = true;
                }
                aemContent.get('CNTCT_US_CALL_TIME_ONE').then(function (data){
                    $scope.call_preference_time_one= data.replace(/[^apm0-9\-]/g, "");
                });
                aemContent.get('CNTCT_US_CALL_TIME_TWO').then(function (data){
                    $scope.call_preference_time_two= data.replace(/[^apm0-9\-]/g, "");
                });
                aemContent.get('CNTCT_US_CALL_TIME_THREE').then(function (data){
                    $scope.call_preference_time_three= data.replace(/[^apm0-9\-]/g, "");
                });



            };

            _fetchPlansAndCSPhoneNumber();

            $scope.formatPhone = function(){
                var phoneNumber = $scope.contactUsForm.phone;

                $scope.contactUsForm.phone =  $filter('formatPhone')(phoneNumber);
            };
            var savePayload =function(){
                var memberInfo = session.data.memberInfo;
                var selectedMessagePlan ="";
                var messageTopicLabel="";
                var messageTopicValue="";
                if($scope.messagePlans){
                    $scope.messagePlans.forEach(function(messagePlan){
                        if(messagePlan.id==$scope.contactUsForm.planId){
                            selectedMessagePlan = messagePlan;
                        }
                    });
                }
                if($scope.topics && $scope.contactUsForm.reason){
                    $scope.topics.forEach(function(topic){
                        if(topic.categoryCode==$scope.contactUsForm.reason){
                            messageTopicLabel = topic.label;
                            messageTopicValue = topic.value;
                        }
                    })

                }
                var selectedGroup = 0;
                var selectedPlan = 0;
                var selectedClientIndex=0;
                var selectedMember = 0;
                var _messageToReplyTo ="";
                if(!$scope.reply){

                    selectedClientIndex = selectedMessagePlan.selectedClientIndex;
                    selectedGroup = selectedMessagePlan.selectedGroup;
                    selectedPlan = selectedMessagePlan.selectedPlan;


                }else{
                    var _messageToReplyTo =$scope._messageToReplyTo;
                    //get Selected Client Index
                    for (var a = 0; a < memberInfo.clientList.length; a++) {
                        if(memberInfo.clientList[a].clientNumber === _messageToReplyTo.clientNumber){
                            // Get Selected Group Index
                            for (var b = 0; b <memberInfo.clientList[a].groupList.length; b++) {
                                if(memberInfo.clientList[a].groupList[b].groupNumber === _messageToReplyTo.groupNumber){
                                    // Get Selected Plan Index
                                    for (var c = 0; c < memberInfo.clientList[a].groupList[b].productList.length; c++) {
                                        if(memberInfo.clientList[a].groupList[b].productList[c].productNumber + c === _messageToReplyTo.productNumber + c){
                                            //we've got the right client, group, and plan so let's use them
                                            selectedClientIndex = a;
                                            selectedGroup = b;
                                            selectedPlan = c;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }

                }
                var memberECID = (_messageToReplyTo ? _messageToReplyTo.ecid : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[0].ecId);
                for (var d = 0; d < memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList.length; d++) {
                    if(memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[d].ecId === memberECID){
                        selectedMember = d;
                        break;
                    }
                }
                var coverageStartDate = memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].coverageConBeginDate;
                if(coverageStartDate == null || coverageStartDate == ""){
                    coverageStartDate = memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].coverageBeginDate;
                }

                var attachments = $scope.attachedFiles.length>0?angular.copy($scope.attachedFiles):[];
                if(attachments && attachments.length>0){
                    attachments.forEach(function(attachment){
                        delete attachment.fileSize;
                        delete attachment.fileBinary;
                        delete attachment.fileUploadStatus;
                    })
                }
                   var payload= {
                            "agreementId": memberInfo.agreementId,
                           "conversationID": (_messageToReplyTo ? _messageToReplyTo.conversationID : ""),
                           "ecId": (_messageToReplyTo ? _messageToReplyTo.ecid : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].ecId),
                           "umi": memberInfo.umi,
                           "coveredIndividualId": (_messageToReplyTo ? _messageToReplyTo.ciId : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].coveredIndividualId),
                           "clientNumber": (_messageToReplyTo ? _messageToReplyTo.clientNumber : memberInfo.clientList[selectedClientIndex].clientNumber),
                           "clientName": (_messageToReplyTo ? _messageToReplyTo.clientName : memberInfo.clientList[selectedClientIndex].clientName),
                           "groupNumber": (_messageToReplyTo ? _messageToReplyTo.groupNumber : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].groupNumber),
                           "productNumber": (_messageToReplyTo ? _messageToReplyTo.productNumber : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].productNumber),
                           "benefitPlanType": (_messageToReplyTo ? _messageToReplyTo.benefitPlanType : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].benefitPlanType),
                           "benefitPlanName": (_messageToReplyTo ? _messageToReplyTo.benefitPlanName : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].benefitPlanName),
                           "bdUserId" : 'B'+ memberInfo.bvUserId,
                           "clientId" : (_messageToReplyTo ? memberInfo.clientList[selectedClientIndex].clientId : memberInfo.clientList[selectedClientIndex].clientId),
                           "internalGroupNumber" : (_messageToReplyTo ? memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].internalGroupNumber : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].internalGroupNumber),
                           "firstName": (_messageToReplyTo ? _messageToReplyTo.memberFirstName : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].contact.firstName),
                           "lastName": (_messageToReplyTo ? _messageToReplyTo.memberLastName : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].contact.lastName),
                           "middleName": (_messageToReplyTo ? _messageToReplyTo.memberMiddleName : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].contact.middleName),
                           "suffix": (_messageToReplyTo ? _messageToReplyTo.memberSuffix : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].contact.suffix),
                           "birthDate": (_messageToReplyTo ? dateStringToMMDDYYYY(_messageToReplyTo.memberBirthDate) : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].contact.birthDate),
                           "relationshipCode": (_messageToReplyTo ? _messageToReplyTo.campaignMessageRelationshipCode : memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].relationshipCode),
                           "messageID": (_messageToReplyTo ? _messageToReplyTo.campaignMessageId : messageTopicValue),
                           "direction": "inbound",
                           "messageSource": "Member Portal",
                           "subject": (_messageToReplyTo ? _messageToReplyTo.subject : messageTopicLabel),
                           "phoneNumber": $scope.contactUsForm.phone.replace('(', '').replace(')', '').replace(' ', '').replace('+', '').replace('-', ''),
                           "callTimePreference": brand==='mincr' ? "" : $scope.contactUsForm.callPreference,//(window.mcqFlag || brand==='mincr'
                           "leaveMessageInd": $scope.contactUsForm.leaveMessage,
                           "emailAddress": "",
                           "notificationMethod": "",
                           "notificationAddress": "",
                           "createIdentifier": "mbr",
                           "dcn": "",
                           "languageCode": "",
                           "channelCode": "IS",
                           "gender": memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].memberList[selectedMember].gender,
                           "enrollmentSourceCode": memberInfo.clientList[selectedClientIndex].enrollmentSourceCode,
                           "brand": brand,
                           "lob": memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].lob,
                           "alphaPrefix": memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].alphaPrefix,
                           //"coverageBeginDate": memberInfo.clientList[selectedClientIndex].groupList[selectedGroup].productList[selectedPlan].coverageBeginDate,
                           "coverageBeginDate": coverageStartDate,
                           "coverageEndDate": "",
                           "externalSystemIdentifier": (_messageToReplyTo ? _messageToReplyTo.externalSystemId : ""),
                           "messages": [
                           {
                               "message": $scope.contactUsForm.comments
                           }
                       ],
                           "attachments": attachments
                   };
                   console.log("payload"+payload);
                   services.rbsmbl.addMessage().save(payload).then(function(response){
                       if(response!=null) {
                       var modalButtons=[

                           {
                               buttonLabel:"OK",
                               buttonClass:"primary",
                               buttonAction:function(){$scope.closeModal();
                                   $window.location  = "/member/msg";
                                   }
                           }
                       ];
                       $scope.modalTitle = 'SUCCESS';
                       var modalDescription = "Your message was submitted successfully. We will send you an email when you have a reply waiting in your message center."//'Your message was submitted successfully. A nurse will attempt to reach you within 24 hours.';

                       openAttachmentAlertModal('SUCCESS',modalDescription,modalButtons);
                       }
                   },function(error){
                       var modalButtons=[
                           {
                               buttonLabel:"OK",
                               buttonClass:"primary",
                               buttonAction:function(){$scope.closeModal();
                                   $window.location  = "/member/msg";
                               }
                           }
                       ];
                       openAttachmentAlertModal('Error','Message not sent',modalButtons);
                   });


            };



            $scope.submitMessageForm = function(contactUsMessageForm){
                console.log("contactUsMessageForm"+contactUsMessageForm);
                if(contactUsMessageForm.$invalid){
                    return;
                }else{
                    savePayload();
                }


            };




            // function to format bytes, will move to a filter
            var formatBytes = function(bytes, decimals) {
                if (bytes === 0) {
                    return '0 bytes'
                }
                var k = 1000,
                    dm = decimals + 1 || 3,
                    sizes = [' bytes', ' kb', ' mb'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + '' + sizes[i];
            };


            var filterTopicOptions = function() {

                var topicOptionsNew = $scope.topics.slice();
                var memberInfo = session.data.memberInfo;
                var selectedPlanId = $scope.contactUsForm.planId;

                if(selectedPlanId) {
                    // console.log("mbrmb:",data);
                    var mcqApplies = false;
                    var mcqInArray = false;
                    var today = new Date();
                    var re = /^(\d{4})-(\d{2})-(\d{2})$/;
                    var re2 = /^(\d{2})\/(\d{2})\/(\d{4})$/;
                    var start = {};
                    var end = {};
                    var selectedProduct = {};
                    var selectedPlanObjArrIndex;
                    var topicIndex;

                    var valueArr = selectedPlanId.split("_");
                    var selectedPlanObjId = valueArr[0]+valueArr[1]+valueArr[2];
                    selectedPlanObjArrIndex = valueArr[3];


                    // this block is designed to remove the message topic to contact a nurse if the user does not have a current medical plan. Since the memberInfo svc returns two possible date formats, there are two cases for handling the date

                    // Retrieve the selected plan object
                    for (var iClntIdx = 0; iClntIdx < memberInfo.clientList.length; ++iClntIdx) {
                        var objClnt = memberInfo.clientList[iClntIdx];
                        for (var iGrpIdx = 0; iGrpIdx < objClnt.groupList.length; ++iGrpIdx) {
                            var objGrp = objClnt.groupList[iGrpIdx];
                            //console.log("objGrp:",objGrp);
                            for (var iPrdIdx = 0; iPrdIdx < objGrp.productList.length; ++iPrdIdx) {
                                var objPrd = objGrp.productList[iPrdIdx];
                                if (selectedPlanObjId && selectedPlanObjId === objPrd.lob + objGrp.groupNumber + objPrd.productNumber && parseInt(selectedPlanObjArrIndex) === iPrdIdx) {
                                    selectedProduct = objPrd;
                                    var isHCR = objPrd.hcrProduct;
                                    var effectuatedDate = objPrd.effectuatedDate;
                                    var isDirPay = objGrp.directPayIndicator;

                                    //console.log("iPrdIdx:",iPrdIdx);
                                    break;
                                }
                            }
                        }
                    }

                    // determine if mcq topic is in the array
                    if (topicOptionsNew) {
                        for (var x = 0; x < topicOptionsNew.length; x++) {
                            if (topicOptionsNew[x].label.toUpperCase() === "DISCUSS HEALTH WITH A NURSE") {
                                mcqInArray = true;
                                topicIndex = x;
                                break;
                            }
                        }
                    }
                    // case for handling first date format
                    // both cases create date objects that are ready for >/< comparisons
                    if (selectedProduct.coverageBeginDate && selectedProduct.coverageBeginDate.match(re)) {
                        var startDateArr = selectedProduct.coverageBeginDate.split('-');
                        var endDateArr = selectedProduct.coverageEndDate.split('-');
                        var start = new Date(startDateArr[0], startDateArr[1], startDateArr[2]);
                        var end = new Date(endDateArr[0], endDateArr[1], endDateArr[2]);
                    }

                    //case for handling second date
                    else if (selectedProduct.coverageBeginDate && selectedProduct.coverageBeginDate.match(re2)) {
                        //y,m,d
                        var startDateArr = selectedProduct.coverageBeginDate.split('/');
                        var endDateArr = selectedProduct.coverageEndDate.split('/');
                        var start = new Date(startDateArr[2], startDateArr[0] - 1, startDateArr[1]);
                        var end = new Date(endDateArr[2], endDateArr[0] - 1, endDateArr[1]);
                    }

                    var sharedBrandCode = brand;
                    for (var i = 0; i < topicOptionsNew.length; i++) {
                        if (topicOptionsNew[i].label.toLowerCase() === 'discuss health with a nurse'){
                            if (!(sharedBrandCode.toLowerCase() === 'hmbcbs' || sharedBrandCode.toLowerCase() === 'hbs' ||
                                sharedBrandCode.toLowerCase() === 'hmbcbsde' || sharedBrandCode.toLowerCase() === 'mbh' ||
                                sharedBrandCode.toLowerCase() === 'az' || sharedBrandCode.toLowerCase() === 'pbs' ||
                                sharedBrandCode.toLowerCase() === 'hz' || sharedBrandCode.toLowerCase() === 'fl' ||
                                sharedBrandCode.toLowerCase() === 'ms' || sharedBrandCode.toLowerCase() === 'ibc' ||
                                sharedBrandCode.toLowerCase() === 'exc' || sharedBrandCode.toLowerCase() === 'lou' ||
                                sharedBrandCode.toLowerCase() === 'ne' || sharedBrandCode.toLowerCase() === 'regbcbs' ||
                                sharedBrandCode.toLowerCase() === 'regbs' || sharedBrandCode.toLowerCase() === 'wi' ||
                                sharedBrandCode.toLowerCase() === 'none' || sharedBrandCode.toLowerCase() === 'pp' ||
                                sharedBrandCode.toLowerCase() === 'mn' ||
                                sharedBrandCode.toLowerCase() === 'hhic' || sharedBrandCode.toLowerCase() === 'hmbcbswv' ||
                                sharedBrandCode.toLowerCase() === 'ibccr' || sharedBrandCode.toLowerCase() === 'ibcah' ||
                                sharedBrandCode.toLowerCase() === 'mincr' || sharedBrandCode.toLowerCase() === 'ndbcbs' ||
                                sharedBrandCode.toLowerCase() === 'wybcbs' || sharedBrandCode.toLowerCase() === 'la')) {

                                topicOptionsNew.splice(i,1);
                            }

                        }

                    }

                    // if you find a current medical plan during the iteration, set the member clinical question flag to true

                    if (selectedProduct.benefitPlanType && selectedProduct.benefitPlanType.toUpperCase() === 'MEDICAL'
                        && selectedProduct.coverageCancelDate === ""
                        && (start < today && today < end)
                        && !(isHCR && isDirPay && effectuatedDate === "")) {

                        mcqApplies = true;
                    }
                    else {
                        mcqApplies = false;
                    }

                    if (!mcqApplies && mcqInArray) {
                        var node = topicOptionsNew.splice(topicIndex, 1)[0];
                        $scope.mcqTopicNode = {
                            "index" : topicIndex,
                            "node" : node
                        }

                    }
                    if (!mcqInArray && mcqApplies) {
                        var node = $scope.mcqTopicNode;
                        topicOptionsNew.splice(node.index, 0, node.node);
                    }
                };


                if ((ahPartner === 'AHNJ' && medicare === 'true')
                    || (ahPartner === 'AHNJ' && medigap === 'true')
                    || (blueExtraBasic == 'true' || blueExtraPlus == 'true')
                    || (brand === 'ibccr' && medicare === 'true' && isHMO === 'true')
                    || (brand === 'ibccr' && medicare === 'true' && isPPO === 'true')) {
                    for (var index = 0; index < topicOptionsNew.length; index++) {
                        if (topicOptionsNew[index].label === 'Claim Inquiry' || topicOptionsNew[index].label === 'Spending Accounts') {
                            topicOptionsNew.splice(index,1);
                        }
                    }
                }



                return topicOptionsNew;
            };


            $scope.changePlan=function(){
                if($scope.contactUsForm.reason){
                    $scope.planChangeWarning =true;
                }
                $scope.contactUsForm.reason="";
                $scope.topics = filterTopicOptions();
            };
            var clearContactUsForm = function(){
                $scope.contactUsForm = {
                    planId:"",
                    reason:"",
                    comments:"",
                    phone:"",
                    attachment: "",
                    callPreference: "",
                    leaveMessage:""
                };
            };




            $scope.downloadAttachment = function(attachmentId) {

                var mimeType = 'application/octet-stream';
                var downloadAttachment = "";
                if (attachmentId){
                    $scope.attachedFiles.forEach(function (attachment) {
                        if (attachment.attachmentId === attachmentId) {
                            downloadAttachment = attachment;
                        }
                    });
                }

                if (downloadAttachment && downloadAttachment.fileName) {
                    switch ((downloadAttachment.fileName.split('.')[1]).toLowerCase()) {
                        case 'txt':
                            mimeType = 'text/plain';
                            break;
                        case 'pdf':
                            mimeType = 'application/pdf';
                            break;
                        case 'doc':
                            mimeType = 'application/msword';
                            break;
                        case 'docx':
                            mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                            break;
                        case 'xls':
                            mimeType = 'application/vnd.ms-excel';
                            break;
                        case 'xlsx':
                            mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                            break;
                        case 'jpg':
                        case 'gif':
                        case 'png':
                            mimeType = 'image/*';
                            break;
                        default:
                            mimeType = 'application/octet-stream';
                    }
                }

                var fileName = downloadAttachment.fileName;



                //for now we will reach the RBSMBL Wrapper for this, regardless of browser

                var uri = downloadAttachmentUrl + "?documentToken=" + downloadAttachment.attachmentPath + "&mimeType=" + mimeType + "&fileName=" + fileName;
                var link = document.createElement("a");
                link.href = uri;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            };

            $scope.closeModal = function(){
                modal.close();
            };



            var dateStringToMMDDYYYY = function (str){
                if(str !== ""){
                    var dateArray = str.split("-");
                    var year = dateArray[0];
                    var month = dateArray[1];
                    var day = dateArray[2];
                    return  month + "/" + day + "/" + year;

                } else {
                    return "";
                }
            };

            var openAttachmentAlertModal =function(title,description,buttons){
                $scope.modalTitle = title;
                $scope.modalDescription = description;
                if(buttons){
                    $scope.modalButtons =buttons;
                }else {
                    $scope.modalButtons = [
                        {
                            buttonLabel: "OK",
                            buttonClass: "primary",
                            buttonAction: function () {
                                $scope.closeModal()
                            }
                        }
                    ];
                }
                modal.open({
                    template: require('chmhom/modals/attachFileAlertModal.html'),
                    controller: attachFileAlertModal,
                    scope: $scope
                });
            };

            var setSideBarNavigation=function(){
                var heading="";
                var label="";
                var description="";
                if ($scope.reply) {
                    heading = '<span data-aem-content="MSG_REPLY_LFT_NAV_TTL"></span>';

                    description = '<p class="contactus-sidebar" ><span data-aem-content="MSG_REPLY_LFT_NAV_DSC"></span></p>';
                    var leftNavCall ='<p class="contactus-sidebar" ><span data-aem-content="MSG_REPLY_LFT_NAV_NUM"></span></p>';

                    description = description+leftNavCall;
                } else {
                    heading= 'CONTACT US';


                    var leftNavCall = "";
                    var leftNavDesc='<p class="contactus-sidebar-margin-top" ><span data-aem-content="CNTCT_US_LEFTNAV_DESC"></span></p>';
                    if (brand == "hmbcbs" || brand == "de" || brand == "pbs") {
                        var csPhone=$scope.CSPhoneNumber;
                        if (csPhone && csPhone.replace(/\s/g, '').trim().length <= 0) {
                            leftNavCall = "<p class='contactus-sidebar-margin-top' >Haven't found what you're looking for? Find <a target=\"_blank\" href=\"/chmptl/chm/jsp/contactus.do?oid=-13447&submitbutton=custserv\">other ways to contact Highmark</a>. For technical questions, please call 1-877-298-3918.</p>";

                        } else {
                            leftNavCall= "<p class='contactus-sidebar' >Haven't found what you're looking for? Call " + $scope.CSPhoneNumber + ". Or, for technical questions, please call 1-877-298-3918</p>";
                        }
                    }else {
                        leftNavCall= '<p class="contactus-sidebar" ><span data-aem-content="CNTCT_US_LEFTNAV_CALL"></span></p>';
                    }
                    description=leftNavDesc+leftNavCall;
                }

                $scope.sidebar.links.push({
                    heading: heading,
                    label: label,
                    description: description

                });

            };
            $timeout(function(){
                setSideBarNavigation();
            },500);


        }]
    );
}